<script lang="ts">
    import {_} from 'svelte-i18n'
    import {mySession} from './services';
    import Textfield from '@smui/textfield';
    import HelperText from '@smui/textfield/helper-text';
    import Button from '@smui/button';
    import {Label} from '@smui/common';

    let username: string = '';
    let password: string = '';

    function submit() {
        mySession.loginOperator({username, password});
    }
</script>

<div style="margin: 20px 0 10px 0; padding: 10px 0">
    <div class="mdc-typography--headline4">{$_('user.auth.EmployeeLogin')}</div>

    <form on:submit|preventDefault={submit} style="display: flex; flex-direction: row; align-items: center; box-sizing: border-box;">
        <div>
            <Textfield bind:value={username} label={$_('user.auth.Username')} input$aria-describedby="operator-username-input-helper-text" />
            <HelperText id="operator-username-input-helper-text"> </HelperText>
        </div>
        <div style="margin-left: 10px">
            <Textfield type="password" bind:value={password} label={$_('user.auth.Password')} input$aria-describedby="operator-password-input-helper-text" />
            <HelperText id="operator-password-input-helper-text"> </HelperText>
        </div>
        <div style="margin-left: 10px">
            <Button type="submit" variant="unelevated"><Label>{$_('user.auth.Login')}</Label></Button>
        </div>
    </form>
</div>